import "./tripExtraDetails.css";

import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Popover, Typography } from "antd";

import UserRequestDTO from "../../../../shared/dtos/userRequestDTO";
import {
  DoorIcon,
  ManagerIcon,
  NoteIcon,
  PlaneIcon,
  UserIcon,
} from "../../../../shared/constants/Images";
import { CardItem } from "../../../../shared/components/CardImageText";

const { Text } = Typography;

interface TripExtraDetailsProps {
  userRequest: UserRequestDTO;
  isTextDarkMode: boolean;
  isLote: boolean;
  passengerNames: string[];
}

const TripExtraDetails = ({
  userRequest,
  isTextDarkMode,
  isLote,
  passengerNames,
}: TripExtraDetailsProps) => {
  const detailCount = [
    isLote && passengerNames.length > 0,
    userRequest.departmentCode,
    userRequest.flightNumber,
    userRequest.reason,
    userRequest.responsible,
  ].filter(Boolean).length;

  if (detailCount === 0) {
    return null;
  }

  const content = (
    <div className="trip-extra-details-popover">
      {isLote && passengerNames.length > 0 && (
        <div className="trip-extra-details-section">
          <Text type="secondary" className="trip-extra-details-label">
            Pasajeros del lote
          </Text>
          {passengerNames.map((name) => (
            <CardItem
              key={name}
              isTextDarkMode={isTextDarkMode}
              src={UserIcon}
              text={name}
            />
          ))}
        </div>
      )}
      {userRequest.departmentCode && (
        <CardItem
          isTextDarkMode={isTextDarkMode}
          src={DoorIcon}
          text={`Departamento: ${userRequest.departmentCode}`}
          strong
        />
      )}
      {userRequest.flightNumber && (
        <CardItem
          isTextDarkMode={isTextDarkMode}
          src={PlaneIcon}
          text={`Número de vuelo: ${userRequest.flightNumber}`}
          strong
        />
      )}
      {userRequest.reason && (
        <CardItem
          isTextDarkMode={isTextDarkMode}
          src={NoteIcon}
          text={`Motivo: ${userRequest.reason}`}
          strong
        />
      )}
      {userRequest.responsible && (
        <CardItem
          isTextDarkMode={isTextDarkMode}
          src={ManagerIcon}
          text={`Responsable: ${userRequest.responsible}`}
          strong
        />
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      title="Detalles adicionales"
      trigger="click"
      placement="rightTop"
    >
      <Button
        type="link"
        size="small"
        className="trip-extra-details-trigger"
        icon={<InfoCircleOutlined />}
        onClick={(event) => event.stopPropagation()}
      >
        Más detalles ({detailCount})
      </Button>
    </Popover>
  );
};

export default TripExtraDetails;
